
enum ApiAction {
    ADD = 'add',
    REMOVE = 'remove',
    UPDATE = 'update',
    REPLACE = 'replace',
    DELETE = 'delete'
}

export default ApiAction;
